import { AbilityBuilder, createMongoAbility } from '@casl/ability';
import type { RawRuleOf } from '@casl/ability';
import type { CompanySettingsAccessContext } from '@/abilities/companySettings/context';
import { COMPANY_SETTINGS_DESTINATION, type CompanySettingsAbility } from '@/abilities/companySettings/vocabulary';

export const companySettingsBankFeedRules = ({
  bankFeedConnectionViewGranted,
  isAdmin,
}: Pick<
  CompanySettingsAccessContext,
  'bankFeedConnectionViewGranted' | 'isAdmin'
>): RawRuleOf<CompanySettingsAbility>[] => {
  const { can, rules } = new AbilityBuilder<CompanySettingsAbility>(createMongoAbility);
  if (bankFeedConnectionViewGranted) {
    can(['see', 'open'], COMPANY_SETTINGS_DESTINATION, {
      destination: { $in: ['bankFeed.connections', 'bankFeed.synchronization'] },
    });
    can('see', COMPANY_SETTINGS_DESTINATION, { destination: 'bankFeed.usersAndPermissions' });
    if (isAdmin) can('open', COMPANY_SETTINGS_DESTINATION, { destination: 'bankFeed.usersAndPermissions' });
  }
  return rules;
};
